import { render, staticRenderFns } from "./SetHandlingFee.vue?vue&type=template&id=59715807"
import script from "./SetHandlingFee.vue?vue&type=script&lang=js"
export * from "./SetHandlingFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports